import type { BariPostEnrollmentDataV2 } from '@common/validation/customControls/bariPost/bariPostEnrollment/v2/bariPostEnrollmentDataV2';
import { initialDataV1 } from '../v1/bariPostEnrollmentEditDataV1';

export const initialDataV2: BariPostEnrollmentDataV2 = {
    ...initialDataV1,
    HDL_cholesterol: null,
    LDL_cholesterol: null,
    hba1c: null,
    triglyceriden: null,
};
